import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersonsByIdNumCtrlDig } from '../../../../core/entities/personsByIdNumCtrlDig.model';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { PETICIONES } from 'src/app/core/utils/constants';
import { SelectItem } from 'primeng/api';
import * as _ from 'lodash';

@Injectable()
export class DialogsTercerService {

    persons: PersonsByIdNumCtrlDig = new PersonsByIdNumCtrlDig();
    allPersons: PersonsByIdNumCtrlDig[] = new Array<PersonsByIdNumCtrlDig>();
    nif: string = "";

    optionsTercer: SelectItem[] = [];
    optionsTercerBase: SelectItem[] = [];

    constructor(private repositoryService: RepositoryService) { }

    init(data: any): Observable<boolean> {
        return forkJoin([this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + data.nif)]).pipe(map(dataGroup => {
            this.optionsTercerBase.push({ value: null, label: "" });
            this.allPersons = dataGroup[0].personsByIdNumCtrlDig;
            for (let i = 0; i < this.allPersons.length; i++) {
                this.optionsTercerBase.push({ value: this.allPersons[i].dboid, label: this.allPersons[i].fullname });
              }
            this.optionsTercer = this.optionsTercerBase;
            this.optionsTercerBase = [];
            return true;
        }));
    }
}